import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';
import FormsProps from '@components/shared/mixins/forms/props';

/**
 * Division Props
 */
@Component
class Props extends Mixins(CommonProps, FormsProps) {
    /**
     * lower limit of divisions
     */
    @Prop({ type: String }) limit!: string

    /**
     * value of neighborhood as higher limit
     */
    @Prop({ type: [String, Number] }) neighborhood!: string | number

    /**
     * value of city as higher limit
     */
    @Prop({ type: [String, Number] }) city!: string | number

    /**
     * value of province as higher limit
     */
    @Prop({ type: [String, Number] }) province!: string | number

    /**
     * value of country as higher limit
     */
    @Prop({ type: [String, Number] }) country!: string | number

    /**
     * value of continent as higher limit
     */
    @Prop({ type: [String, Number] }) continent!: string | number

    /**
     * allow divisions select to be empty
     */
    @Prop({ type: Boolean }) allowEmpty!: boolean

    /**
     * Disable or hide next level
     */
    @Prop({ type: Boolean }) hideEmpties!: boolean

    /**
     * Enable Multi Option for each Item
     */
    @Prop({ type: Array, default: () => [] }) multi!: Array<any>
}

export default Props;
